<template>
  <div id="app" style="background-color: #f7f8fa;">
    <router-view/>
  </div>
</template>
<script>
  export default {
  name: 'App'
}

</script>

<style>





</style>
